import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import eye from "../../assets/eye.png";
import { createColumnHelper } from "@tanstack/react-table";
import ReactTable from "../../components/ReactTable";
import CustomPagination from "../../components/CustomPagination";
import ReusableModal from "../../components/ReusableModal";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;

const toastIds = {
  uploadSuccess: 'report-upload-success-toast',
  uploadError: 'report-upload-error-toast',
  fetchError: 'report-fetch-error-toast'
};

function InvestorReportEdit() {
  const navigate = useNavigate();
  const [investorUserDetails, setInvestorUserDetails] = useState([]);
  const [latestReports, setLatestReports] = useState([]);
  const [previousReports, setPreviousReports] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { userPermissionData } = useSelector((state) => state.userPermission);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPazeSize] = useState(0);
  const [error, setError] = useState(null);
  const [reportFile, setUploadReportFile] = useState();
  const location = useLocation();
  const id = location?.state?.uniqueId;

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/reports/${id}`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      console.log("response report", response);
      setInvestorUserDetails(response?.data?.data?.investorDetails); // Adjust according to your API response structure
      setLatestReports(response?.data?.data?.reports || []);
      setPreviousReports(response?.data?.data?.prevReports || []);
      setPage(1);
      setTotal(2);
      setPazeSize(10);
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, []);

  const openModal = () => {
    setUploadReportFile();
    setIsModalOpen(true);
  }; // Function to open modal
  const closeModal = () => {
    setUploadReportFile();
    setIsModalOpen(false);
  }; // Function to close modal

  const columnHelper = createColumnHelper();

  const columns = [
    columnHelper.accessor("createdAt", {
      cell: (info) => {
        let createdAt = info?.getValue();
        // Check if the date value exists before formatting
        createdAt = createdAt ? moment(createdAt).format("DD-MM-YYYY") : "N/A";
        return createdAt;
      },
      header: () => <span>Date</span>,
    }),

    columnHelper.accessor("fileName", {
      cell: (info) => (info.renderValue() ? `${info.renderValue()}` : "N/A"),
      header: () => (
        <div className=" ">
          <span>Full Name</span>
        </div>
      ),
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        console.log("investorid", uniqueId);
        const NavigateScheme = (uniqueId) => {
          window.open(info?.row?.original?.fileUrl, "_blank"); // Opens the link in a new tab

          // navigate("/bond/edit", {
          //   state: {
          //     uniqueId: uniqueId,
          //   },
          // });
        };
        const deleteBond = (id) => {
          // deleteBondsId(id);
        };
        return (
          <div className="flex justify-start ">
            <img
              onClick={() => NavigateScheme(uniqueId)}
              src={eye}
              alt="Eye "
              className="cursor-pointer pr-8"
            />
            {/* <img
                onClick={() => deleteBond(uniqueId)}
                src={delBond}
                alt="Eye "
                className="cursor-pointer"
              /> */}
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  const handleReportFileUpload = async () => {
    console.log("reportFile", reportFile);
    const endpoint = `${base_url}/${api_type}/report`;
    const formData = new FormData();

    formData.append("file", reportFile);
    formData.append("investorId", id);

    try {
      const response = await axios.post(endpoint, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      
      // Close modal first
      setUploadReportFile();
      closeModal();
      
      // Then show success message
      if (!toast.isActive(toastIds.uploadSuccess)) {
        toast.success(response?.data?.message || "Report uploaded successfully", {
          toastId: toastIds.uploadSuccess,
          autoClose: 3000
        });
      }

      // Refresh the data
      await fetchInvestorDetails();
      
    } catch (err) {
      if (!toast.isActive(toastIds.uploadError)) {
        toast.error(err?.response?.data?.message || "Failed to upload report", {
          toastId: toastIds.uploadError,
          autoClose: 3000
        });
      }
      console.error("Failed to upload report:", err);
      setError(err.message);
    }
  };

  console.log("reportFile", reportFile);

  return (
    <>
      <div className="w-full mt-[60px] ml-4">
        <div>
          <button
            onClick={() => navigate("/report")}
            className="border-none bg-transparent text-gray-700 text-sm font-bold cursor-pointer py-2.5"
          >
            ← Back
          </button>
        </div>

        <div className="bg-white rounded-lg mt-3 mb-3 w-full font-bold border border-1 border-gray-300 pt-3">
          <h2 className="text-md font-bold px-5 pb-2">Investor Details</h2>
          <div className="border-b border-1 border-gray-300"></div>
          <div className="grid grid-cols-3 gap-5 p-5">
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                UCC Code
              </label>
              <input
                type="text"
                disabled={true}
                placeholder=""
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Investor Name
              </label>
              <input
                type="text"
                placeholder="John Smith"
                disabled={true}
                value={investorUserDetails?.name}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Settlement Date
              </label>
              <input
                type="text"
                placeholder=""
                disabled
                value={
                  investorUserDetails?.settlementDate
                    ? moment(investorUserDetails.settlementDate).format("DD/MM/YYYY")
                    : ''
                }
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Last Invested
              </label>
              <input
                type="text"
                placeholder="15/11/2024"
                disabled={true}
                value={
                  investorUserDetails?.lastInvested
                    ? moment(investorUserDetails?.lastInvested).format(
                        "DD/MM/YYYY"
                      )
                    : "N/A"
                }
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
            <div>
              <label className="text-gray-600 text-xs block mb-1.5">
                Total Amount Invested
              </label>
              <input
                type="text"
                disabled={true}
                placeholder="₹850,000"
                value={`₹ ${investorUserDetails?.totalAmountInvested}`}
                className="bg-gray-50 p-2.5 rounded w-full text-sm text-gray-600 border-none"
              />
            </div>
          </div>
        </div>

        <div className="flex gap-2.5 flex-grow justify-end">
          {userPermissionData?.report?.upload && (
            <button
              className="border bg-[#035C98] text-white px-4 py-1 rounded-[10px] cursor-pointer flex gap-2"
              onClick={openModal}
            >
              Upload
            </button>
          )}
        </div>

        {/* Modal Component */}
        {isModalOpen && (
          <ReusableModal
            title="Upload Report"
            content={
              <>
                <label>Upload File</label>
                <label className="cursor-pointer">
                  <input
                    type="file"
                    className="hidden"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setUploadReportFile(e.target.files[0])}
                  />
                  <div className="bg-gray-100 rounded-[10px] mt-2 p-2.5 flex items-center justify-between">
                    <div className="flex items-center gap-2 text-gray-500">
                      <svg
                        className="w-5 h-5"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                      {reportFile ? (
                        <span>{reportFile?.name}</span>
                      ) : (
                        <span>Select File</span>
                      )}
                    </div>
                    <svg
                      className="w-5 h-5 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0l-4 4m4-4v12"
                      />
                    </svg>
                  </div>
                </label>
              </>
            }
            ButtonValue="Upload"
            onUpload={handleReportFileUpload}
            onClose={closeModal} // Close modal on button click
          />
        )}

        <div className="bg-white rounded-lg mt-3 mb-3 w-full font-bold border border-1 border-gray-300 pt-3">
          <div className="flex justify-between items-center mb-3 w-full font-bold text-nowrap px-5">
            <h2>Latest Report </h2>
          </div>

          <div className="border-b border-1 border-gray-300 "></div>

          <div className="w-full font-poppins">
            <ReactTable
              key={JSON?.stringify(latestReports)}
              defaultData={latestReports}
              columns={columns}
            />
          </div>
        </div>

        <div className="bg-white rounded-lg mt-3 mb-3 w-full font-bold border border-1 border-gray-300 pt-3">
          <div className="flex justify-between items-center mb-3 w-full font-bold text-nowrap px-5">
            <h2>Previous Report </h2>
          </div>

          <div className="border-b border-1 border-gray-300 "></div>

          <div className="w-full font-poppins">
            <ReactTable
              key={JSON?.stringify(previousReports)}
              defaultData={previousReports}
              columns={columns}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default InvestorReportEdit;
